var _style, _circle, _circle2, _rect, _rect2, _rect3, _rect4, _circle3, _rect5, _path, _circle4, _circle5, _circle6, _path2, _path3, _polygon, _path4, _path5, _ellipse, _path6, _path7, _path8, _path9, _circle7, _path0, _polygon2, _polygon3, _polygon4, _polygon5, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 454.2 454.2",
    style: {
      enableBackground: "new 0 0 454.2 454.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#509B69;}\n\t.st2{fill:#7AE5A5;}\n\t.st3{fill:#65C189;}\n\t.st4{fill:#88EFB2;}\n\t.st5{fill:#0B1921;}\n\t.st6{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.4885,
    y1: 59.5112,
    x2: 133.4744,
    y2: 563.5616,
    gradientTransform: "matrix(1 0 0 -1 0 456)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#20355B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A7B68C"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 227.1,
    cy: 227.1,
    r: 227.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 112.2,
    cy: 203.8,
    r: 13.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 211.4,
    y: 279.1,
    className: "st2",
    width: 28.6,
    height: 44.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 174.6,
    className: "st3",
    width: 40.3,
    height: 58.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 128.3,
    y: 121.3,
    className: "st4",
    width: 197.1,
    height: 162.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 187.6,
    y: 102.4,
    className: "st4",
    width: 76.2,
    height: 34
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 338.5,
    cy: 203.8,
    r: 13.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 301.2,
    y: 174.6,
    className: "st3",
    width: 40.3,
    height: 58.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M221.6,105.8V83.9c0,0-1.1-7.9,6.1-7.9c7.3,0,20.1,0,20.1,0V58.2h10.7v19.4c0,0,1,9.1-6.6,9.1s-20.2,0-20.2,0 v20.6L221.6,105.8z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 253,
    cy: 42.5,
    r: 18.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 185.5,
    cy: 186.5,
    r: 17.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 193.6,
    cy: 176.6,
    r: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M315.6,360c0,0,41.8,2.6,51.3-41.1l3.6-4.7H391c0,0,5.7,64.7-75.4,72.2s-4.2-18-4.2-18L315.6,360z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.5,343.9h17.2c0,0,2.9-0.3,2.9,4.5s0,40.3,0,40.3s-0.2,2-1.8,2c-1.5,0-17.2,0-17.2,0L297.5,343.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "226.9,102.4 226.9,283.5 325.5,283.5 325.5,121.3 264.9,121.3 264.9,102.4  "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M137.5,360c0,0-41.8,2.6-51.3-41.1l-3.6-4.7H62.1c0,0-5.7,64.7,75.4,72.2s4.2-18,4.2-18L137.5,360z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.6,343.9h-17.2c0,0-2.9-0.3-2.9,4.5s0,40.3,0,40.3s0.2,2,1.8,2s17.2,0,17.2,0L155.6,343.9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 38.3759 418.1055)",
    className: "st5",
    cx: 264.9,
    cy: 186.5,
    rx: 17.3,
    ry: 17.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M189.7,234.4h11.8c0,0-2.7,20.7,26.4,20.7s25.8-20.7,25.8-20.7h11.4c0,0,0,29.6-36.1,29.6 S189.7,237.3,189.7,234.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M370.9,275.5l-8.5-11.4c0,0-15.5,13.4-12.9,31.3c2.7,18,17.5,26.4,32.5,25.2c15.1-1.2,28.6-12.1,27.2-33.5 c0,0,1.7-11.7-13.4-23.1l-7.5,11.9c0,0,9.5,5.2,7,16.4s-7,13.9-16.1,14.9s-17.4-8.3-16.6-19.2C363.3,277.1,370.9,275.5,370.9,275.5 z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.2,275.5l8.5-11.4c0,0,15.5,13.4,12.9,31.3c-2.7,18-17.5,26.4-32.5,25.2s-28.6-12.1-27.2-33.5 c0,0-1.7-11.7,13.4-23.1l7.5,11.9c0,0-9.5,5.2-7,16.4s7,13.9,16.1,14.9s17.4-8.3,16.6-19.2C89.8,277.1,82.2,275.5,82.2,275.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M151.2,441.2c23.7,8.4,49.3,13,75.9,13c25.9,0,50.9-4.4,74.1-12.4V320.6h-150L151.2,441.2L151.2,441.2z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 274.4,
    cy: 176.6,
    r: 4
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.9,454.2c0.1,0,0.1,0,0.2,0c25.9,0,50.9-4.4,74.1-12.4V320.6l-74.3-2.3L226.9,454.2L226.9,454.2z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "331.7,349.7 340.4,387.7 357.1,384.1 344.4,346.9  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "379.8,363 354.6,333.8 358.3,326.5 388.6,352.6  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "124.8,353.2 115.4,385.8 95.4,380 110.9,349.9  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "69.2,357.4 99.1,338.1 95.9,328.7 62,344.5  "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M278.3,359.8c-0.4-4.9-3.9-8.4-8.2-8.4c-2.9,0-5.5,1.6-7,4c-1.5-2.5-4-4-6.8-4c-4.3,0-7.8,3.5-8.2,8.4 c0,0.2-0.2,1.4,0.3,3.2c0.6,2.7,2.1,5.1,4.2,7l10.6,9.6L274,370c2.1-1.9,3.6-4.4,4.2-7C278.5,361.2,278.4,360,278.3,359.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarRobot);
export default __webpack_public_path__ + "static/media/avatar-robot.21101a8d60b9b04498e04c245602350f.svg";
export { ForwardRef as ReactComponent };